export default {
	highestBidOrOffer: {
		PROXY: 'Highest bid',
		SALE: 'Highest offer',
	},
};
